import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  showSpinner: boolean;

  constructor() { }

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  show() {
    console.log('show loading');

    this.loadingSubject.next(true);
  }

  hide() {

    this.loadingSubject.next(false);
  }

}
